import I18n from "i18n";
import vent from "libraries/vent";
import React from "react";

export default function DetailUpdateAvailable() {
  return (
    <a
      className="link-bar__right-item"
      onClick={() => vent.trigger("click:updateResult")}
    >
      <i className="legacy-icon-recover-small-dark"></i>
      {I18n.t("webapp.agents.results.result_details.update_result")}
    </a>
  );
}
